import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="playlist--selector"
export default class extends Controller {
  connect() {
  }

  submitForm(event) {
    const form = event.target.closest('form')
    if (form) {
      form.requestSubmit()
    }
  }
}
